export enum CommentTypeEnum {
  public = 1,
  private = 2,
}
